export const quizImg = {
    quizUrl: '/img/gif/quiz.webp',
    examUrl: '/img/online_exam.webp'
}

export const msOfficeQuestions = [
    {
        question: 'Which of the following is spreadsheet program?',
        option1: 'Ms-word',
        option2: 'Ms-power point',
        option3: 'Ms-excel',
        option4: 'Ms-access',
        answer: 3
    },
    {
        question: 'Ms excel is used for creating',
        option1: 'Presentations',
        option2: 'Documents',
        option3: 'Sending mails',
        option4: 'Spreadsheets',
        answer: 4
    },
    {
        question: 'Ms-power point is a ________ language',
        option1: 'Document',
        option2: 'Spreadsheet',
        option3: 'Presentation',
        option4: 'programmatic',
        answer: 3
    },
    {
        question: 'The combination of row and column is called ______________',
        option1: 'Line',
        option2: 'Colum',
        option3: 'Cell',
        option4: 'Row',
        answer: 3
    },
    {
        question: 'Which is not a font style?',
        option1: 'Bold',
        option2: 'Superscript',
        option3: 'Regular',
        option4: 'Italic',
        answer: 2
    },
    {
        question: 'Landscape is?',
        option1: 'A font style',
        option2: 'Page Orientation',
        option3: 'Paper Size',
        option4: 'Page Layout',
        answer: 2
    },
    {
        question: 'Background color on a document is not visible in?',
        option1: 'Print Preview',
        option2: 'Web layout view',
        option3: 'Print Layout view',
        option4: 'Reading View',
        answer: 1
    },
    {
        question: 'Ctrl+P shortcut key is used for',
        option1: 'Deleting the document',
        option2: 'Saving the document',
        option3: 'Printing the document',
        option4: 'Mailing the document',
        answer: 3
    },
    {
        question: 'Watermark option is available in _________ menu',
        option1: 'Insert',
        option2: 'Mailing',
        option3: 'References',
        option4: 'Design',
        answer: 4
    },
    {
        question: 'Escape key is used in power point for',
        option1: 'Open new slide',
        option2: 'Deleting slide',
        option3: 'Saving the slide',
        option4: 'Come out of slide show',
        answer: 4
    },
    {
        question: 'ClipArt option is available in ___________ menu',
        option1: 'Insert',
        option2: 'Page Layout',
        option3: 'References',
        option4: 'Home',
        answer: 1
    },
    {
        question: 'Which is not a type of margin?',
        option1: 'Left',
        option2: 'Center',
        option3: 'Top',
        option4: 'Right',
        answer: 2
    },
    {
        question: 'What does MS stand for in MS Office?',
        option1: 'Main Software',
        option2: 'Master Suite',
        option3: 'Microsoft',
        option4: 'Multi-System',
        answer: 3
    },
    {
        question: 'Who invented Microsoft Office?',
        option1: 'Richard Brodie',
        option2: 'Mark Zuckerberg',
        option3: 'Steve Jobs',
        option4: 'Bill Gates and Paul Allen',
        answer: 4
    },
    {
        question: 'When was Microsoft Office first released?',
        option1: '1995',
        option2: '1989',
        option3: '1985',
        option4: '2000',
        answer: 2
    },
    {
        question: 'Which application in MS Office is used to create documents and letters?',
        option1: 'Microsoft Teams',
        option2: 'Microsoft Access',
        option3: 'Microsoft Excel',
        option4: 'Microsoft Word',
        answer: 4
    },
    {
        question: 'What is the purpose of the File menu in MS Office applications?',
        option1: 'To insert animations',
        option2: 'To access Save, Open, Print, and New options',
        option3: 'To close documents',
        option4: 'To share documents on social media',
        answer: 2
    },
    {
        question: 'From which menu you can insert Header and Footer?',
        option1: 'Insert Menu',
        option2: 'View Menu',
        option3: 'Format menu',
        option4: 'Tools Menu',
        answer: 1
    },
    {
        question: 'Bullets and Numbering is in tab.',
        option1: 'Home tab',
        option2: 'Insert tab',
        option3: 'Pagelayout tab',
        option4: 'View tab',
        answer: 1
    },
    {
        question: '__________ is an option in Font Group.',
        option1: 'Strikethrough',
        option2: 'Find',
        option3: 'Replace',
        option4: 'Change Styles',
        answer: 1
    },
    {
        question: 'Cut, Copy and Paste is in ________ Group in the Home tab.',
        option1: 'Font',
        option2: 'Page Setup',
        option3: 'Clipboard',
        option4: 'Editing',
        answer: 3
    },
    {
        question: '__________ is used to convert from upper case to lower case and vice versa.',
        option1: 'Toggle case',
        option2: 'Sentence case',
        option3: 'Lower case',
        option4: 'Upper case',
        answer: 1
    },
    {
        question: 'What is the smallest and largest font size available in Font Size tool on formatting toolbar?',
        option1: '8 and 72',
        option2: '8 and 64',
        option3: '12 and 72',
        option4: 'None of above',
        answer: 1
    },
    {
        question: 'Portrait and Landscape are',
        option1: 'Page Orientation',
        option2: 'Paper Size',
        option3: 'Page Layout',
        option4: 'All of above',
        answer: 1
    },
    {
        question: 'Excel files have a default extension of',
        option1: 'Xls',
        option2: 'Xlw',
        option3: 'Wk1',
        option4: '123',
        answer: 1
    }
];

export const dtpQuestions = [
  {
    question: 'Which software is primarily used for page layout and design?',
    option1: 'Photoshop',
    option2: 'PageMaker',
    option3: 'Notepad',
    option4: 'CorelDRAW',
    answer: 2
  },
  {
    question: 'Which DTP tool is best known for vector illustration?',
    option1: 'PageMaker',
    option2: 'Photoshop',
    option3: 'CorelDRAW',
    option4: 'Paint',
    answer: 3
  },
  {
    question: 'Which DTP application is raster‑based and ideal for photo editing?',
    option1: 'CorelDRAW',
    option2: 'PageMaker',
    option3: 'InDesign',
    option4: 'Photoshop',
    answer: 4
  },
  {
    question: 'PageMaker was developed by which company?',
    option1: 'Adobe',
    option2: 'Microsoft',
    option3: 'Corel',
    option4: 'Apple',
    answer: 1
  },
  {
    question: 'CorelDRAW is primarily used for?',
    option1: 'Page layout',
    option2: 'Vector graphics',
    option3: 'Raster editing',
    option4: 'Database management',
    answer: 2
  },
  {
    question: 'Photoshop supports which color mode best for print?',
    option1: 'RGB',
    option2: 'CMYK',
    option3: 'Indexed',
    option4: 'Grayscale',
    answer: 2
  },
  {
    question: 'In PageMaker, master pages are used for?',
    option1: 'Image editing',
    option2: 'Global layout consistency',
    option3: 'Typographic styles only',
    option4: 'Saving files',
    answer: 2
  },
  {
    question: 'Which software uses layers extensively?',
    option1: 'PageMaker',
    option2: 'Notepad',
    option3: 'CorelDRAW',
    option4: 'Excel',
    answer: 3
  },
  {
    question: 'Which file extension does Photoshop use for its native format?',
    option1: '.psd',
    option2: '.pmd',
    option3: '.cdr',
    option4: '.tif',
    answer: 1
  },
  {
    question: 'PageMaker file native extension is?',
    option1: '.psd',
    option2: '.indd',
    option3: '.pmd',
    option4: '.cdr',
    answer: 3
  },
  {
    question: 'CorelDRAW native file extension is?',
    option1: '.cdr',
    option2: '.pdf',
    option3: '.png',
    option4: '.ai',
    answer: 1
  },
  {
    question: 'Which tool is best for creating brochures and flyers?',
    option1: 'CorelDRAW',
    option2: 'PageMaker',
    option3: 'Photoshop',
    option4: 'Notepad',
    answer: 2
  },
  {
    question: 'Vector graphics are scalable without quality loss. True or false?',
    option1: 'True',
    option2: 'False',
    option3: 'Only in Photoshop',
    option4: 'Only in PageMaker',
    answer: 1
  },
  {
    question: 'Raster images are made of?',
    option1: 'Lines and curves',
    option2: 'Pixels',
    option3: 'Vectors',
    option4: 'Text only',
    answer: 2
  },
  {
    question: 'Which DTP tool integrates best for photo retouching?',
    option1: 'PageMaker',
    option2: 'CorelDRAW',
    option3: 'Photoshop',
    option4: 'WordPad',
    answer: 3
  },
  {
    question: 'CorelDRAW is particularly known for its?',
    option1: 'Photo filters',
    option2: 'Vector drawing tools',
    option3: 'Page layout grids',
    option4: 'Layer blending modes',
    answer: 2
  },
  {
    question: 'In DTP, bleed refers to?',
    option1: 'Extra margin for trimming',
    option2: 'Vector capacity',
    option3: 'Raster resolution',
    option4: 'Color mode',
    answer: 1
  },
  {
    question: 'Which software includes a text flow feature linking text frames?',
    option1: 'Photoshop',
    option2: 'CorelDRAW',
    option3: 'PageMaker',
    option4: 'Paint',
    answer: 3
  },
  {
    question: 'The pen tool is found in which application(s)?',
    option1: 'Photoshop only',
    option2: 'CorelDRAW only',
    option3: 'Both Photoshop & CorelDRAW',
    option4: 'PageMaker only',
    answer: 3
  },
  {
    question: 'Which DTP package was among the first desktop publishing tools on the Mac?',
    option1: 'Photoshop',
    option2: 'PageMaker',
    option3: 'CorelDRAW',
    option4: 'WordPerfect',
    answer: 2
  },
  {
    question: 'Proofing colors intended for print is best in which mode?',
    option1: 'RGB',
    option2: 'CMYK',
    option3: 'Indexed',
    option4: 'Grayscale',
    answer: 2
  },
  {
    question: 'Which is not a standard DTP tool?',
    option1: 'Photoshop',
    option2: 'PageMaker',
    option3: 'CorelDRAW',
    option4: 'Excel',
    answer: 4
  },
  {
    question: 'Which tool is best for vector image logo creation?',
    option1: 'Photoshop',
    option2: 'PageMaker',
    option3: 'CorelDRAW',
    option4: 'Paint',
    answer: 3
  },
  {
    question: 'Photoshop is best suited for?',
    option1: 'Vector illustrations',
    option2: 'Page layout',
    option3: 'Raster editing',
    option4: 'Database creation',
    answer: 3
  },
  {
    question: 'PageMaker was later replaced by which Adobe product?',
    option1: 'Illustrator',
    option2: 'InDesign',
    option3: 'Photoshop',
    option4: 'Dreamweaver',
    answer: 2
  }
];


export const cLanguageQuestions = [
  {
    question: 'Who developed the C programming language?',
    option1: 'Dennis Ritchie',
    option2: 'Bjarne Stroustrup',
    option3: 'Ken Thompson',
    option4: 'James Gosling',
    answer: 1
  },
  {
    question: 'In which decade was C developed?',
    option1: '1960s',
    option2: '1970s',
    option3: '1980s',
    option4: '1990s',
    answer: 2
  },
  {
    question: 'The file extension for C source files is?',
    option1: '.cpp',
    option2: '.c',
    option3: '.java',
    option4: '.py',
    answer: 2
  },
  {
    question: 'Which of these is a correct comment in C?',
    option1: '/* Comment */',
    option2: '// Comment //',
    option3: '# Comment #',
    option4: '<!-- Comment -->',
    answer: 1
  },
  {
    question: 'Which one is the correct symbol for the logical AND operator?',
    option1: '&',
    option2: '&&',
    option3: '||',
    option4: '!',
    answer: 2
  },
  {
    question: 'What does “printf” function do?',
    option1: 'Read input from user',
    option2: 'Print output to console',
    option3: 'Pause program',
    option4: 'Exit program',
    answer: 2
  },
  {
    question: 'Which header file is required for “printf”?',
    option1: '<conio.h>',
    option2: '<stdio.h>',
    option3: '<stdlib.h>',
    option4: '<string.h>',
    answer: 2
  },
  {
    question: 'Which is the loop structure that executes at least once?',
    option1: 'for',
    option2: 'while',
    option3: 'do‑while',
    option4: 'if',
    answer: 3
  },
  {
    question: 'What is the correct syntax to declare an integer variable named count?',
    option1: 'int count;',
    option2: 'count int;',
    option3: 'integer count;',
    option4: 'var count;',
    answer: 1
  },
  {
    question: 'Which operator is used to access the value at a pointer?',
    option1: '&',
    option2: '*',
    option3: '%',
    option4: '^',
    answer: 2
  },
  {
    question: 'The return type of main function should be?',
    option1: 'void',
    option2: 'int',
    option3: 'float',
    option4: 'char',
    answer: 2
  },
  {
    question: 'Which function is used to allocate memory dynamically?',
    option1: 'malloc',
    option2: 'alloc',
    option3: 'new',
    option4: 'dynalloc',
    answer: 1
  },
  {
    question: 'Which keyword is used to define a constant?',
    option1: 'constant',
    option2: 'final',
    option3: 'const',
    option4: 'immutable',
    answer: 3
  },
  {
    question: 'Which operator gives remainder of division?',
    option1: '/',
    option2: '%',
    option3: '÷',
    option4: '\\',
    answer: 2
  },
  {
    question: 'Which function reads formatted input?',
    option1: 'scanf',
    option2: 'readf',
    option3: 'getf',
    option4: 'inputf',
    answer: 1
  },
  {
    question: 'String handling functions are in which header?',
    option1: '<math.h>',
    option2: '<stdio.h>',
    option3: '<string.h>',
    option4: '<stdlib.h>',
    answer: 3
  },
  {
    question: 'Which keyword is used to return a value from a function?',
    option1: 'exit',
    option2: 'return',
    option3: 'goto',
    option4: 'break',
    answer: 2
  },
  {
    question: 'Which of the following is not a valid variable name in C?',
    option1: 'intValue',
    option2: '_value',
    option3: '1value',
    option4: 'value_1',
    answer: 3
  },
  {
    question: 'What is the size of “char” in C (in bytes)?',
    option1: '1',
    option2: '2',
    option3: '4',
    option4: 'Depends on compiler',
    answer: 1
  },
  {
    question: 'Which loop is best used when loop count is known?',
    option1: 'while',
    option2: 'do‑while',
    option3: 'for',
    option4: 'if',
    answer: 3
  },
  {
    question: 'How do you write “Hello, World!” in C?',
    option1: 'print("Hello, World!");',
    option2: 'printf("Hello, World!");',
    option3: 'cout << "Hello, World!";',
    option4: 'echo "Hello, World!";',
    answer: 2
  },
  {
    question: 'Which header file provides “malloc” and “free”?',
    option1: '<stdio.h>',
    option2: '<stdlib.h>',
    option3: '<memory.h>',
    option4: '<conio.h>',
    answer: 2
  },
  {
    question: 'Pointer variable holds ________ of another variable.',
    option1: 'value',
    option2: 'address',
    option3: 'type',
    option4: 'size',
    answer: 2
  },
  {
    question: 'Which of these is not a storage class in C?',
    option1: 'auto',
    option2: 'register',
    option3: 'static',
    option4: 'shared',
    answer: 4
  }
];

    